import { ApiService } from "src/network/apiService";

export class MobileAppViewModel {
    private apiService: ApiService;

    constructor(accessToken: string) {
        this.apiService = new ApiService({ accessToken: accessToken });
    }


}
